import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../../../store/LocationDetail";

class InvoicesTable extends Component{
  constructor(props) {
    super(props);

    this.state = {
     
    };

    this.handleClick = this.handleClick.bind(this);
  }
  
  componentDidMount(){
    if (this.props.invoices.length === 0){
      this.props.setInvoices();
    }
  }

  handleClick(event){
    let id = event.currentTarget.getAttribute("id");
    this.props.history.push("/services/" + id);
  }
  
  render(){
    return(
      <table className="cdb-small-table">
        <tbody>
          <tr>
            <th>#</th>
            <th>Service</th>
            <th>Invoiced Date</th>
            <th>Total Due</th>
            <th>Balance Due</th>
            <th>Image</th>
            <th>Service #</th>
          </tr>
          {this.props.invoices.map((row) => {
            return(
              <tr key={row.id} style={{cursor: 'pointer'}}>
                <td>{row.invoiceNo}</td>
                <td>{row.type}</td>
                <td>{row.invoicedDate}</td>
                <td>${row.customerTotal}</td>
                <td>${row.custBalanceDue}</td>
                <td>
                  {row.image ?
                    <a href={`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/document${row.image.url}`}
                       target='_blank' rel='noopener noreferrer'>
                      <span className="icon-view-assignment"/>
                    </a>
                    : ''
                  }
                </td>
                <td id={row.workOrderNo} onClick={this.handleClick}>{row.workOrderNo}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

}

const mapStateToProps = function(state) {
  return {
    invoices: state.locationDetail.invoices,
  }
};

export default withRouter(connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(InvoicesTable));